<template>
  <v-card>
    <v-card-title>Agentes da equipe</v-card-title>

    <v-card-text>
      <v-expand-transition>
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </v-expand-transition>

      <v-expand-transition>
        <v-data-table
          :headers="headers"
          :items="agentesSituacoes"
          class="elevation-2"
          no-data-text="Nenhum agente disponível"
          :footer-props="{
            'items-per-page-text': 'Agentes por página',
            'page-text': '{0}-{1} de {2}',
            'items-per-page-all-text': 'Todos',
          }"
        >
          <template #item.agenteNome="{ item }">
            <td>
              <v-avatar
                :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
                size="32"
              >
                <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
                  {{ item.agenteNome.toUpperCase().charAt(0) }}{{ item.agenteNome.toUpperCase().charAt(1) }}
                </span>
              </v-avatar>
              <span class="ms-2">
                {{ item.agenteNome }}
              </span>
            </td>
          </template>

          <template #item.logado="{ item }">
            <v-chip
              v-if="item.logado"
              color="success"
              outlined
            >
              Logado
            </v-chip>

            <v-chip
              v-else
              color="error"
              outlined
            >
              Deslogado
            </v-chip>
          </template>

          <template #item.pausaNome="{ item }">
            <v-chip
              v-if="item.emPausa"
              color="primary"
              outlined
            >
              {{ item.pausaNome }}
            </v-chip>
          </template>

          <template #item.tempoEmPausa="{ item }">
            <agentes-situacoes-data-registro
              v-if="item.emPausa"
              color="secondary"
              :data-registro="item.dataRegistroPausa"
            />
          </template>

          <template #item.tempoLogado="{ item }">
            <agentes-situacoes-data-registro
              v-if="item.logado"
              color="info"
              :data-registro="item.dataRegistroLogin"
            />
          </template>

          <template
            #[`item.actions`]="{ item }"
          >
            <v-menu
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  class="ml-n5"
                  color="primary"
                  v-on="on"
                >
                  <v-icon>
                    {{ icons.mdiDotsVertical }}
                  </v-icon>
                </v-btn>
              </template>
              <v-list
                v-if="item.logado"
              >
                <v-list-item>
                  <v-list-item-title
                    role="button"
                    class="d-flex"
                    @click="deslogarAgente(item)"
                  >
                    <v-icon
                      size="20"
                      class="mr-1"
                    >
                      {{ icons.mdiCloseThick }}
                    </v-icon>
                    <span class="text-capitalize">Deslogar</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import AuthService from '@/services/modules/AuthService'
import getDateDifference from '@/utils/dateDifference'
import AgentesSituacoesDataRegistro from './AgentesSituacoesDataRegistro.vue'

export default {
  components: {
    AgentesSituacoesDataRegistro,
  },

  props: {
    agentesSituacoes: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const headers = [
      { text: 'Agente', value: 'agenteNome' },
      { text: 'Status login', value: 'logado' },
      { text: 'Status pausa', value: 'pausaNome' },
      { text: 'Tempo em pausa', value: 'tempoEmPausa' },
      { text: 'Tempo logado', value: 'tempoLogado' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    async function deslogarAgente(item) {
      await AuthService.logoutAgentePeloGestor(item.agenteId)
    }

    return {
      headers,
      getDateDifference,
      deslogarAgente,
      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
    }
  },
}
</script>
